<script>
import { HotAreaActionHandler } from './actionHandler';

function percent(p) {
  return `${p}%`;
}

export default {
  props: ['instance', 'global', 'meta'],
  render: function (createElement) {
    const { hotAreas } = this.instance.data;
    if (!hotAreas || !hotAreas.length) {
      return null;
    }

    return createElement(
      'div',
      hotAreas.map((hotArea, index) => {
        const { size, position } = hotArea;
        return createElement(HotAreaActionHandler, {
          key: index,
          style: {
            width: percent(size.width),
            height: percent(size.height),
            left: percent(position.x),
            top: percent(position.y),
            cursor: 'pointer',
            position: 'absolute',
            zIndex: 20,
          },
          props: {
            instance: this.instance,
            hotArea,
            meta: this.meta,
            global: this.global,
          },
        });
      })
    );
  },
};
</script>
